<template>
  <div>
    <div class="homework-default-info position-relative">
      <TeacherDefaultCard :show_loader="is_loading"></TeacherDefaultCard>
      <TeacherDefaultCard :show_loader="is_loading"></TeacherDefaultCard>
      <TeacherDefaultCard :show_loader="is_loading"></TeacherDefaultCard>
      <TeacherDefaultCard :show_loader="is_loading"></TeacherDefaultCard>
      <TeacherDefaultCard :show_loader="is_loading"></TeacherDefaultCard>
      <TeacherDefaultCard :show_loader="is_loading"></TeacherDefaultCard>

      <!-- ADD HOMEWORK SECTION -->
      <template v-if="is_empty">
        <EmptyContent
          display_img="EmptyHomework.png"
          display_text="This class has not been assigned homework"
          button_type="emit"
          button_text="Create Assessment"
          button_function="create-homework"
          :show_button="false"
          @create-homework="$emit('create-homework')"
          v-if="account_type === 'school'"
          :show_empty="true"
        ></EmptyContent>

        <template v-if="account_type === 'teacher'">
          <EmptyContent
            v-if="is_subscribed"
            display_img="EmptyHomework.png"
            display_text="No assigned assessment available"
            button_type="emit"
            button_text="Create Assessment"
            button_function="create-homework"
            @create-homework="$emit('create-homework')"
            :show_empty="true"
          ></EmptyContent>

          <EmptyContent
            v-else
            display_img="EmptyHomework.png"
            display_text="No assigned assessment available"
            button_type="emit"
            button_text="Create Assessment"
            button_function="toggleNoSubscription"
            @toggleNoSubscription="$emit('toggleNoSubscription')"
            :show_empty="true"
          ></EmptyContent>
        </template>
      </template>

      <!-- ADD HOMEWORK SECTION -->
    </div>
  </div>
</template>

<script>
import EmptyContent from "@/components/globalComps/EmptyContent";
import TeacherDefaultCard from "@/components/classComps/members/teachers/TeacherDefaultCard";

export default {
  name: "DefaultInfo",

  props: {
    is_empty: {
      type: Boolean,
      default: false,
    },
    is_loading: {
      type: Boolean,
      default: true,
    },
    is_subscribed: {
      type: Boolean,
      default: false,
    },
  },

  components: {
    TeacherDefaultCard,
    EmptyContent,
  },

  data() {
    return {
      account_type: "",
    };
  },

  created() {
    this.getAccountType();
  },

  methods: {
    getAccountType() {
      this.account_type = this.$route.path.split("/")[1];
    },
  },
};
</script>

<style lang="scss">
.homework-default-info {
  margin-top: 30px;
  margin-bottom: 60px;

  @include breakpoint_max(md) {
    margin-bottom: 100px;
  }
}
</style>
